var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.252 15.386c0-3.461-2.835-3.855-5.113-4.172-2.483-.346-3.887-.645-3.887-2.782 0-1.795 1.88-2.432 3.49-2.432a5.065 5.065 0 014.176 1.97l1.167-.94a6.488 6.488 0 00-4.334-2.458V2.25h-1.5v2.266c-2.71.165-4.5 1.696-4.5 3.915 0 3.548 2.873 3.948 5.181 4.268 2.44.34 3.82.632 3.82 2.687 0 2.275-2.35 2.614-3.75 2.614-2.573 0-3.66-.723-4.667-1.97l-1.167.94a6.33 6.33 0 005.083 2.504v2.276h1.5v-2.284c2.795-.228 4.5-1.745 4.5-4.08z",
    fill: "#1C6839"
  })));
}
export default SvgCurrencyDollar;